// @flow
import React from "react";
import { Route, Routes } from "react-router-dom";

// Code-splitted imports
import MyLoadable from "containers/MyLoadable";
import ICPCLoader from "components/ICPCLoader";
import api from "../api";
import { useDispatch } from "react-redux";
import { showErrorMessageSimple } from "../containers/Snackbar/duck";
import Discord from "routes/public/Discord";

const PublicApp = MyLoadable({
  loader: () => import("containers/PublicApp"),
  loading: ICPCLoader,
});
const PrivateApp = MyLoadable({
  loader: () => import("containers/PrivateApp"),
  loading: ICPCLoader,
});
const Login = MyLoadable({
  loader: () => import("routes/auth/Login"),
  loading: ICPCLoader,
});
const Register = MyLoadable({
  loader: () => import("routes/auth/Register"),
  loading: ICPCLoader,
});

const HotelPublicApp = MyLoadable({
  loader: () => import("hotel/src/containers/PublicApp"),
  loading: ICPCLoader,
});
const HotelPrivateApp = MyLoadable({
  loader: () => import("hotel/src/containers/PrivateApp"),
  loading: ICPCLoader,
});
const TempRedirect = MyLoadable({
  loader: () => import("routes/public/TempRedirect"),
  loading: ICPCLoader,
});

function AppRoute(props: any) {
  const { history, authInitialized } = props;
  let dispatch = useDispatch();
  api.setError((message) => {
    dispatch(showErrorMessageSimple(message));
  });
  return (
    <Routes>
      {authInitialized && <Route path="/private/*" element={<PrivateApp />} />}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register activate={false} />} />
      <Route path="/activate" element={<Register activate={true} />} />
      {authInitialized && (
        <Route path="/hotel/private/*" element={<HotelPrivateApp />} />
      )}
      <Route path="/hotel/public/*" element={<HotelPublicApp />} />
      <Route path="/hotel/*" element={<HotelPublicApp />} />
      <Route
        path="/worldfinals/acmicpc/ICPC-Policies-and-Procedures-04-16-2018-c.pdf"
        element={<TempRedirect />}
      />
      <Route path="/discord" element={<Discord />} />
      <Route path="/*" element={<PublicApp />} />
    </Routes>
  );
}

export default AppRoute;
